import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../api/client";
import { customDateFormatType2, formatNumber } from "../utils/utils";

const queryKey = "honor";

async function fetchHonor(type, projectId, startTime, endTime) {
  try {
    const options = {};

    if (projectId) options.projectId = projectId;
    if (startTime) options.startTime = customDateFormatType2(startTime);
    if (endTime) options.endTime = customDateFormatType2(endTime);

    const queryParams = new URLSearchParams(options).toString();
    // let data = await clientAPI("get", `/locking/honor?${queryParams}`);
    let data = null;

    if(type===1){
      data= await clientAPI("get", `/commissionAnalyst/honor?${queryParams}`);
    }else if(type===2){
      data= await clientAPI("get", `/commissionAnalyst/areaHonor?${queryParams}`);
    }else if(type===3){
      data= await clientAPI("get", `/commissionAnalyst/blockHonor?${queryParams}`);
    }
    

    const newData = data?.items.map((item, index) => {
      return {
        name: item?.employeeObject?.fullName || "-",
        totalValue: item?.amountPayable
          ? `${formatNumber(item?.amountPayable)} VNĐ`
          : "0 VNĐ",
      };
    });

    return { data: newData };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useHonor(type, projectId, startTime, endTime) {
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey, type, projectId, startTime, endTime],
    queryFn: () => fetchHonor(type, projectId, startTime, endTime),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });

  return {
    honorData: data?.data,
    refetch,
    isLoading,
    isRefetching,
  };
}
